import {Component, Inject} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {DialogData} from "../book-toolbar-v2/book-toolbar-v2.component";

@Component({

  selector: 'rw-supported-company-information-dialog',  // <home></home>

  styles: [require('./supported-company-information-dialog.component.css')],

  template: require('./supported-company-information-dialog.component.html')
})
export class SupportedCompanyInformationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SupportedCompanyInformationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ){}
  validateInfo(): void {
    this.dialogRef.close();
  }
}




// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/supported-company-information-dialog/supported-company-information-dialog.component.ts